<script>

import { store } from './store.js'
import SVGMap from './components/SVGMap.vue';

export default {

  name: 'VueSalesManagerMap',
  components: {
    SVGMap
  },

  mounted(){
    this.fetchRegions();
  },

  data() {
    return {
        store,
        regionsLoading: true,
        allRegions: []
      }
    },


  methods: {

    fetchRegions: async function() {
      fetch(`/wp-json/wp/v2/region?per_page=100`)
        .then(response => response.json())
        .then(response => {

         this.regionsLoading = false
         const data = response;

          data.map((item) => {
            this.allRegions.push(item)
          })
      })
    },


    // URL Setter
    queryStringSetter: function(key, value) {
      let url = new URL(window.location);
      let params = new URLSearchParams(url.search);
      params.set(key, value);
      window.history.replaceState({}, '', `${location.pathname}?${params}`);
    },


    // URL Setter
    // queryStringGetter: function(key, value) {
    //   let url = new URL(window.location);
    //   let params = new URLSearchParams(url.search);
    //   params.append(key, value);
    //   window.history.replaceState({}, '', `${location.pathname}?${params}`);
    // },



    // handleRegionSelect: function(event) {
    //   // const result = this.allRegions.filter(item => item.name == event.target.value);
    //   store.selectedRegion = result;
    //   // this.queryStringSetter('region', event.target.value)
    // },
  },
}

</script>


<template>
  <div class="section-wrapper background-white">
    <section class="map-section">

      <div class="loader-wrapper" v-if="regionsLoading">
        <div class="loader"></div>
      </div>

      <div class="svgMap-wrapper" v-if="!regionsLoading">

        <SVGMap></SVGMap>

        <div v-for="(region, index) in allRegions" :key="region.id">

          <div class="svgMap-pop-up"
            v-if="region.acf.region_sales_manager && store.selectedRegionPath == region.slug"
            :id="region.slug">

            <img class="svgMap-pop-up-image" v-if="region.acf.region_sales_manager?.acf.image" :src="region.acf.region_sales_manager?.acf.image.sizes.thumbnail"/>
            <div class="svgMap-pop-up-content">
              <p v-if="region.name" class="svgMap-pop-up-subheading">{{region.name}}</p>
              <h2 class="svgMap-pop-up-heading">{{region.acf.region_sales_manager?.post_title}}</h2>
              <p v-if="region.acf.region_sales_manager?.acf.role" class="svgMap-pop-up-subheading">{{region.acf.region_sales_manager?.acf.role}}</p>
              <a v-if="region.acf.region_sales_manager?.acf.phone" :href="`tel:${region.acf.region_sales_manager?.acf.phone}`">{{region.acf.region_sales_manager?.acf.phone}}</a>
              <a v-if="region.acf.region_sales_manager?.acf.email" class="email" :href="`mailto:${region.acf.region_sales_manager?.acf.email}`">{{region.acf.region_sales_manager?.acf.email}}</a>
            </div>
          </div>

        </div>

      </div>
    </section>
  </div>
</template>
